/* Fator 5 — Filtros e ordenação da categoria e da busca sem recarregar a página.
   Pede à Shopify só a seção (Section Rendering API: ?section_id=), troca o conteúdo dela na tela e atualiza o
   endereço (histórico). Voltar/Avançar do navegador refazem o mesmo. Se o servidor responder com erro, cai na
   navegação normal. Usado por sections/main-collection.liquid e sections/main-search.liquid (window.F5Plp.go). */
(function () {
  'use strict';
  if (window.F5Plp) return;

  var ctrl = null;   // pedido em andamento: um clique novo cancela o anterior (vale o último)
  // Seção da lista que já foi trocada por aqui: o Voltar/Avançar troca a mesma. Não dá para achá-la por
  // [data-search] na página toda, porque o campo de busca do cabeçalho também tem esse atributo.
  var secaoId = null;
  // Endereço (sem o #) que a lista está mostrando: um link com # também dispara o popstate, e aí não há o que trocar
  var atual = location.pathname + location.search;
  var ultimoAlvo = null;   // último filtro mexido (no iPhone o toque na caixa não dá foco a ela)
  var aviso = null;        // região que o leitor de tela lê: anuncia a nova contagem

  function sectionId(wrap) {
    var id = wrap && wrap.id;
    return id && id.indexOf('shopify-section-') === 0 ? id.slice('shopify-section-'.length) : null;
  }

  // Seção da lista nesta página: a lembrada ou, num documento recém-carregado (recarregou a página depois de
  // filtrar, voltou de um produto sem o cache do navegador), a que tem a lista dentro do <main>
  function achaWrap() {
    var w = secaoId && document.getElementById(secaoId);
    if (w) return w;
    var root = document.querySelector('#MainContent [data-plp], #MainContent [data-search]');
    return root ? root.closest('.shopify-section') : null;
  }

  // Troca o miolo da seção, mantém abertos os grupos de filtro que estavam abertos e roda de novo os <script>
  // da seção (filtros, faixa de preço, "Ver mais")
  function swap(wrap, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.shopify-section') || tmp;
    var abertos = {};
    wrap.querySelectorAll('details.filter-group[open] > summary').forEach(function (s) { abertos[s.textContent.trim()] = true; });
    wrap.innerHTML = fresh.innerHTML;
    wrap.querySelectorAll('details.filter-group > summary').forEach(function (s) {
      if (abertos[s.textContent.trim()]) s.parentNode.open = true;
    });
    wrap.querySelectorAll('script').forEach(function (old) {
      var type = old.getAttribute('type');
      if (type && type !== 'text/javascript' && type !== 'module') return;   // JSON de dados fica como está
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // Devolve o foco ao mesmo filtro depois da troca (teclado e leitor de tela). Campo escondido não conta.
  function refoca(wrap, alvo) {
    if (!alvo || !alvo.nome || !window.CSS || !CSS.escape) return;
    var el = alvo.id ? document.getElementById(alvo.id) : null;
    if (!el || !wrap.contains(el)) {
      var sel = '[name="' + CSS.escape(alvo.nome) + '"]:not([type="hidden"])';
      if (alvo.tipo === 'checkbox') sel += '[value="' + CSS.escape(alvo.valor) + '"]';
      el = wrap.querySelector(sel);
    }
    // Celular com o menu de filtros fechado: o filtro mexido está escondido e não recebe foco. O foco vai para o
    // botão "Filtros" (senão cairia no começo da página, e o leitor de tela perderia o lugar).
    if (el && !el.getClientRects().length) {
      var b = wrap.querySelector('[data-filtros-toggle]');
      el = b && b.getClientRects().length ? b : null;
    }
    if (el) el.focus({ preventScroll: true });
  }

  // Leitor de tela: anuncia "N Resultados" (ou "Nenhum produto com esses filtros")
  function anuncia(wrap) {
    var c = wrap.querySelector('.plp__empty') || wrap.querySelector('.plp__count');
    if (!c) return;
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'visually-hidden';
      aviso.setAttribute('role', 'status');
      document.body.appendChild(aviso);
    }
    aviso.textContent = c.textContent.replace(/\s+/g, ' ').trim();
  }

  // Busca: o título da aba ("Pesquisa: N resultados…") acompanha a nova contagem
  function tituloBusca(wrap) {
    var c = wrap.querySelector('.plp__count');
    var n = c && (c.textContent.match(/\d+/) || [])[0];
    if (n && /\d+(?= resultado)/.test(document.title)) document.title = document.title.replace(/\d+(?= resultado)/, n);
  }

  // Lista nova fora da tela (página rolada no computador): sobe até o começo dela, abaixo do cabeçalho fixo
  function mostraLista(wrap) {
    var c = wrap.querySelector('.plp__content');
    if (!c) return;
    var hb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom')) || 0;
    var topo = c.getBoundingClientRect().top;
    if (topo < hb) window.scrollTo(0, window.scrollY + topo - hb - 12);
  }

  // Falha de rede (ou o cliente saindo da página no meio): lista e filtros voltam ao que está na tela
  function desfaz(wrap) {
    wrap.classList.remove('is-loading');
    wrap.removeAttribute('aria-busy');
    wrap.querySelectorAll('[data-filter-form] input[type="checkbox"]').forEach(function (b) { b.checked = b.defaultChecked; });
    wrap.querySelectorAll('[data-sort]').forEach(function (s) {
      for (var i = 0; i < s.options.length; i++) { if (s.options[i].defaultSelected) s.selectedIndex = i; }
    });
  }

  function go(wrap, url, opts) {
    opts = opts || {};
    var id = sectionId(wrap);
    if (!id || !window.fetch || !window.AbortController || !(window.history && history.pushState)) {
      window.location.href = url;
      return;
    }
    if (ctrl) ctrl.abort();
    var meu = ctrl = new AbortController();
    secaoId = wrap.id;
    var destino = new URL(url, window.location.href);
    destino.searchParams.delete('page');
    var endereco = destino.pathname + destino.search;
    var pedido = new URL(destino.toString());
    pedido.searchParams.set('section_id', id);
    var ativo = document.activeElement;
    var alvo = ativo && wrap.contains(ativo) && ativo.type !== 'hidden'
      ? { id: ativo.id, nome: ativo.name, valor: ativo.value, tipo: ativo.type }
      : ultimoAlvo;
    ultimoAlvo = null;
    wrap.classList.add('is-loading');
    wrap.setAttribute('aria-busy', 'true');
    fetch(pedido.toString(), { signal: meu.signal, headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) {
        if (!r.ok) { var e = new Error('HTTP ' + r.status); e.http = true; throw e; }
        return r.text();
      })
      .then(function (html) {
        if (meu !== ctrl) return;
        ctrl = null;
        if (!opts.pop) {
          // Mesmo endereço (ex.: preço acima do maior = sem teto): troca a entrada, sem duplicar no histórico
          if (endereco === atual) history.replaceState({ f5plp: true }, '', endereco);
          else history.pushState({ f5plp: true }, '', endereco);
        }
        atual = endereco;
        // Foco no botão "Filtros" (fechou o menu, ou tocou em "Ver N resultados") quando a lista chegou: o botão é
        // trocado junto com a seção, então o foco vai para o novo, em vez de voltar ao filtro mexido
        var noMenu = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-filtros-toggle]');
        swap(wrap, html);
        wrap.classList.remove('is-loading');
        wrap.removeAttribute('aria-busy');
        if (!opts.pop) mostraLista(wrap);
        tituloBusca(wrap);
        anuncia(wrap);
        var novoBotao = noMenu && wrap.querySelector('[data-filtros-toggle]');
        if (novoBotao) novoBotao.focus({ preventScroll: true });
        else if (alvo) refoca(wrap, alvo);
      })
      .catch(function (e) {
        if (meu !== ctrl || (e && e.name === 'AbortError')) return;
        ctrl = null;
        // Só o erro do servidor vai para a navegação normal. Falha de rede é também o que o Safari dá quando o
        // cliente sai da página no meio do pedido: navegar aí o levaria de volta para a categoria filtrada.
        if (e && e.http) { window.location.href = destino.toString(); return; }
        if (opts.pop) { window.location.reload(); return; }   // o endereço já mudou: recarrega para a lista bater
        desfaz(wrap);
      });
  }

  // Último filtro mexido: o iPhone não dá foco à caixa tocada, e o foco voltaria para o começo da página
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && t.closest && t.closest('[data-filter-form], [data-sort]')) {
      ultimoAlvo = { id: t.id, nome: t.name, valor: t.value, tipo: t.type };
    }
  }, true);

  // Voltar/Avançar entre filtros aplicados sem recarregar
  window.addEventListener('popstate', function () {
    var endereco = location.pathname + location.search;
    if (endereco === atual) return;   // só o # mudou
    var wrap = achaWrap();
    if (wrap) go(wrap, window.location.href, { pop: true });
    else window.location.reload();
  });

  window.F5Plp = { go: go };
})();
